/**
 * @prop {object} exportData - an object contains the api link and label for export
 * @prop {string} exportData.api - the api link for export
 * @prop {string} exportData.label - the label for export
 */

import { ExcelIcon } from "@/constant/imagePath";
import Spinner from "../Spinner";
import { downloadExcelFile } from "@/utils/ExportUtils";
import { useGet } from "@/apiHooks/HttpFunctions";
import { useModalInfo } from "@/context/ModalContext";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

function BaseExport({ exportData: { label, api } }) {
  const { openModalInfo } = useModalInfo();
  const location = useLocation();

  // Extract query params from the URL
  const queryString = useMemo(() => {
    return location.search;
  }, [location.search]);

  const { isFetching: exportIsFetching, refetch: exportRefetch } = useGet({
    enabled: false,
    apiURL: `${api}/export${queryString}`,
    responseType: "blob",
  });

  const handleExport = async () => {
    const { data } = await exportRefetch();
    if (data) {
      downloadExcelFile(data, label);
      openModalInfo("Data exported and downloaded successfully.");
    }
  };
  return (
    <>
      <button
        onClick={handleExport}
        className="h-8 min-w-[120px] px-3 flex items-center justify-center gap-x-2 font-extralight text-sm text-white hover:underline underline-offset-1 rounded-7 bg-excel-gradient disabled:opacity-80 shadow-primary-inset"
        disabled={exportIsFetching}
      >
        <img src={ExcelIcon} className="h-4" alt="Export" />
        <span>.xlsx Export</span>
        {exportIsFetching && <Spinner />}
      </button>
    </>
  );
}

export default BaseExport;
